<template>
  <div>
    <Input v-model="url"/>
    <a :href="url" >下载</a>

  </div>
</template>

<script>
    export default {
      data(){
        return{
          url:'',
        }
      }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/webview/WebView.vue